import { NetworkService } from "./NetworkService";
import { NetworkRequest } from "./NetworkRequest";

export class DynamicTableService {
  static async getAllTableDimensions() {
    try {
      return await NetworkService.request({
        alias: NetworkRequest.GetAllTableDimensions,
        url: `users/tables/dimensions`,
        method: "GET",
      });
    } catch (e) {
      return e;
    }
  }

  static async saveOrUpdateTableDimensions(tableName, dto) {
    try {
      return await NetworkService.request({
        alias: NetworkRequest.SaveOrUpdateTableDimensions,
        url: `users/tables/${tableName}/dimensions`,
        method: "POST",
        data: dto,
      });
    } catch (e) {
      return e;
    }
  }

  static async deleteTableDimensions(tableName) {
    try {
      return await NetworkService.request({
        alias: NetworkRequest.DeleteTableDimensions,
        url: `users/tables/${tableName}/dimensions/delete`,
        method: "POST",
      });
    } catch (e) {
      return e;
    }
  }
}
